import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { AssetEventType, GenericExternalSystemType } from "../../api/assetEvent";
import { ExternalSystem } from "../../api/externalSystemRequest";

export const InvoiceExternalSystems: ExternalSystem[] = [
    {
        title: 'Send for Approval',
        description: 'Transmit your Invoices to your counterparty for approval',
        icon: '/assets/images/inblock_logo_white.png',
        type: 'inblock',
        assetEventType: AssetEventType.inblock_mapper,
        externalSystemType: GenericExternalSystemType.inblock,
        failMessage: 'Failed to send for Approval',
        globalFailMessage: 'Invoice(s) received an error when sending for Approval',
        successMessage: 'Sent for Approval',
        globalSuccessMessage: 'Invoice(s) were successfully sent for Approval',
        waitingMessage: 'Waiting for Approval',
        requiredPermission: UserEntitlementCatalogs.SendForApproval
    },
    {
        title: 'Send to Asset Backed Finance Module',
        description: 'Transmit your Invoices to use in the LiquidX ABF Module',
        icon: '/assets/images/x.png',
        type: 'abf',
        assetEventType: AssetEventType.abf_ingestor,
        externalSystemType: GenericExternalSystemType.abf,
        failMessage: 'Failed to send to ABF',
        globalFailMessage: 'Invoice(s) received an error when sending to ABF',
        successMessage: 'Sent to Asset Backed Finance',
        globalSuccessMessage: 'Invoice(s) were successfully sent to ABF',
        waitingMessage: 'Waiting for Approval',
        requiredPermission: UserEntitlementCatalogs.SendToAssetBackedFinance
    },
    {
        title: 'Send to Supply Chain Finance Module',
        description: 'Transmit your Invoices for use in the LiquidX SCF Module',
        icon: '/assets/images/x.png',
        type: 'scf',
        assetEventType: AssetEventType.scf_ingestor,
        externalSystemType: GenericExternalSystemType.scf,
        failMessage: 'Failed to send to Supply Chain Finance Module',
        globalFailMessage: 'Invoice(s) received an error when sending to Supply Chain Finance Module',
        successMessage: 'Sent to Supply Chain Finance Module',
        globalSuccessMessage: 'Invoice(s) were successfully sent to Supply Chain Finance Module',
        waitingMessage: 'Waiting for Supply Chain Finance Module',
        requiredPermission: UserEntitlementCatalogs.SendToSupplyChainFinance
    }
];
